import { render, staticRenderFns } from "./InventoryReceived.vue?vue&type=template&id=50188caa"
import script from "./InventoryReceived.vue?vue&type=script&lang=js"
export * from "./InventoryReceived.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports